import React from 'react';

import { useNavigate } from 'react-router-dom';

import MemberTypeForm from '../../../components/forms/MemberTypeForm';
import AdminLayout from '../../../components/layout/AdminLayout';
import { useCreateMemberType } from '../../../hooks/useMemberTypeApi';
import { MemberTypeDTO } from '../../../services/apiClient';

const MemberTypeCreate: React.FC = () => {
  const createMemberType = useCreateMemberType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Types', href: '/admin/membertypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberTypeDTO) => {
    try {
      await createMemberType.mutateAsync(data);
      navigate('/admin/membertypes');
    } catch (error) {
      console.error('Error creating MemberType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/membertypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.MemberType.Edit"
    >
      <MemberTypeForm
        initialValues={{} as MemberTypeDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/membertypes')}
      />
    </AdminLayout>
  );
};

export default MemberTypeCreate;
